import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ComponentImporterV2Page } from '@/areas/components/ComponentsImporter/ComponentImporterV2Page';
import { canImportComponents } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// Nothing links here while it is behind `component_importer_v2`: it is reached by URL only.
export const Route = createFileRoute('/_authenticated/components/import')({
    staticData: { access: { permissions: canImportComponents }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ComponentImporterV2Page />;
}
